import { render, staticRenderFns } from "./SignFile.vue?vue&type=template&id=8dc920ea&scoped=true"
import script from "./SignFile.vue?vue&type=script&lang=js"
export * from "./SignFile.vue?vue&type=script&lang=js"
import style0 from "./SignFile.vue?vue&type=style&index=0&id=8dc920ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc920ea",
  null
  
)

export default component.exports